<div class="flex flex-col gap-4">
  <shared-ui-dynamic-form
    [dynamicForm]="dynamicForm()"
    [showHeader]="showHeader()"
    [headerIcon]="headerIcon()"
    [inputWidth]="inputWidth()"
    (formFieldMapChanged)="formFieldMapChanged.emit($event)">
    <ng-template #dropdown let-fieldModel="fieldModel">
      <div #textField [attr.data-index]="fieldModel.index" class="flex flex-col">
        @let fieldKey = fieldModel.key;
        @let control = fieldModel.control;
        <shared-ui-dropdown
          [attr.data-testid]="fieldModel.key"
          [dropdownOptions]="fieldModel.options"
          [selectedOption]="
            typeof control.value === 'string'
              ? fieldModel.options.find((o) => o.value === control.value)
              : control.value
          "
          (input)="manualInputChangeService.onUserInput(documentId(), fieldModel)"
          [formControl]="control"
          [isDisabled]="control.disabled"
          [sortOptions]="false"
          placeholder="Bitte auswählen"
          (focus)="onFieldFocused($event, fieldKey, control)" />
        @if (shouldDisplayError(control)) {
          <span class="text-sm text-red-700">{{ errorText(control) }}</span>
        }
      </div>
    </ng-template>

    <ng-template #textinput let-fieldModel="fieldModel">
      <div #textField [attr.data-index]="fieldModel.index" class="relative flex h-10.5 flex-col">
        @let fieldKey = fieldModel.key;
        @let control = fieldModel.control;
        <div
          contenteditable
          ctExtractionRemoveWrappingCommaInput
          class="field-group-div-input min-h-10.5 w-full resize-none overflow-y-auto rounded border px-2 py-1 ring-1 outline-none"
          [attr.data-testid]="fieldModel.key"
          [formControl]="control"
          (input)="manualInputChangeService.onUserInput(documentId(), fieldModel)"
          (focus)="onFieldFocused($event, fieldKey, control)"
          [ngClass]="getInputClasses(control, fieldKey === currentFieldKey(), true)"
          [isFocused]="fieldKey === currentFieldKey() && focusInputs()"></div>
        @if (isUnchangedFromPrefilledSource(fieldKey, control)) {
          <span
            class="bg-theme-blue absolute -top-1 -left-1 size-2.5 rounded-full"
            [attr.data-testid]="'prefill-marker-' + fieldKey"
            [pTooltip]="getPrefillSourceTooltip(fieldKey)">
          </span>
        }
        @if (shouldDisplayError(control)) {
          <span class="text-sm text-red-700">{{ errorText(control) }}</span>
        }
      </div>
    </ng-template>

    <ng-template #textarea let-fieldModel="fieldModel">
      <div #textField [attr.data-index]="fieldModel.index" class="flex flex-col">
        @let fieldKey = fieldModel.key;
        @let control = fieldModel.control;
        <textarea
          rows="3"
          [attr.data-testid]="fieldModel.key"
          [formControl]="control"
          (input)="manualInputChangeService.onUserInput(documentId(), fieldModel)"
          class="resize-y rounded border px-3 py-2 ring-1"
          (focus)="onFieldFocused($event, fieldKey, control)"
          [ngClass]="getInputClasses(control, fieldKey === currentFieldKey())"
          [isFocused]="fieldKey === currentFieldKey() && focusInputs()"></textarea>
        @if (shouldDisplayError(control)) {
          <span class="text-sm text-red-700">{{ errorText(control) }}</span>
        }
      </div>
    </ng-template>

    <ng-template #date let-fieldModel="fieldModel">
      <div [attr.data-index]="fieldModel.index" class="relative">
        @let fieldKey = fieldModel.key;
        @let control = fieldModel.control;
        <app-datepicker
          class="block h-[42px]"
          [attr.data-testid]="fieldModel.key"
          [control]="control"
          [tailwindClasses]="getInputClasses(control, fieldKey === currentFieldKey())"
          [placeholderText]="''"
          [additionalCloseCondition]="fieldKey !== currentFieldKey()"
          [isFocused]="fieldKey === currentFieldKey() && focusInputs()"
          (selectEvent)="handleDatePickerSelectEvent(fieldModel, $event)"
          (focusEvent)="onFieldFocused($event, fieldKey, control)" />
        @if (isUnchangedFromPrefilledSource(fieldKey, control)) {
          <span
            class="bg-theme-blue absolute -top-1 -left-1 size-2.5 rounded-full"
            [attr.data-testid]="'prefill-marker-' + fieldKey"
            [pTooltip]="getPrefillSourceTooltip(fieldKey)">
          </span>
        }
        @if (shouldDisplayError(control)) {
          <span class="text-sm text-red-700">{{ errorText(control, FieldType.DATE) }}</span>
        }
      </div>
    </ng-template>
  </shared-ui-dynamic-form>
</div>
